export default __webpack_public_path__ + "static/media/aerospace_background.38b01f20.jpg";